import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import {CONTENT_LAB_ROUTES, ROUTES} from '@contentlab/config/routesConstants';

function useContentLabPageName() {
  const {pathname} = useLocation();
  return useMemo(() => {
    if (!pathname) {
      return CONTENT_LAB_ROUTES[ROUTES.CONTENT_LAB];
    }

    const matchingRoute = Object.entries(CONTENT_LAB_ROUTES).find(
      (entry) => entry[0] && pathname.includes(entry[0])
    );
    if (matchingRoute) {
      return matchingRoute[1];
    }
    return CONTENT_LAB_ROUTES[ROUTES.CONTENT_LAB];
  }, [pathname]);
}

export default useContentLabPageName;
